var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// HomeGamesSwiper.tsx
import { Storage } from "../../services/localstorege.service";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import _ from "lodash";
import { useEffect, useState } from "react";
import { gameNavigationMiddleware, loginRequired, useForceUpdate, } from "../../services/misc.functions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { isMobile } from "../../App";
import iconRight from "../../assets/icons/right-arrow.png";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useNavigate } from "react-router";
import { auth, authSubject } from "../../store/auth.store";
import starIcon from "../../assets/icons/star.png";
import diamondIcon from "../../assets/icons/diamond.png";
import clockIcon from "../../assets/icons/clock.png";
import notificationIcon from "../../assets/icons/Notifications.svg";
export function HomeGamesSwiper(_a) {
    var _this = this;
    var _b = _a.gamesGroup, gamesGroup = _b === void 0 ? 0 : _b;
    var _c = useState([]), gamesList = _c[0], setGamesList = _c[1];
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        getGames().then(function (res) {
            if (gamesGroup === 0) {
                setGamesList(res);
            }
            else if (gamesGroup === 1) {
                setGamesList(res.filter(function (game) { return game.is_active === true; }));
            }
            else if (gamesGroup === 2) {
                setGamesList(res.filter(function (game) { return game.is_active === false; }));
            }
        });
    }, [gamesGroup]);
    useEffect(function () {
        var sub = authSubject.subscribe(function () { return forceUpdate(); });
        return function () { return sub.unsubscribe(); };
    }, []);
    var getGames = function () { return __awaiter(_this, void 0, void 0, function () {
        var games, res, sorted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    games = Storage.get("games");
                    if (games)
                        return [2 /*return*/, games];
                    return [4 /*yield*/, api.start("get", env.accounting_api + "/games/api/list-game/", null, false)];
                case 1:
                    res = _a.sent();
                    if (res === null || res === void 0 ? void 0 : res.status) {
                        sorted = _.orderBy(res.data, ["ordering"], "asc");
                        Storage.set("games", sorted, 60 * 60 * 5);
                        return [2 /*return*/, sorted];
                    }
                    return [2 /*return*/, []];
            }
        });
    }); };
    return (_jsx("div", { children: _jsx("div", __assign({ className: "home-games-swiper" }, { children: _jsxs("div", __assign({ className: " " }, { children: [_jsxs("div", __assign({ className: "row align-items-center mb-3" }, { children: [_jsx("div", __assign({ className: "col-lg-6" }, { children: _jsxs("h2", __assign({ className: "title" }, { children: [gamesGroup === 0 && (_jsxs(_Fragment, { children: [_jsx("img", { src: diamondIcon, alt: "Diamond Icon" }), "Dijital Oyunlar"] })), gamesGroup === 1 && (_jsxs(_Fragment, { children: [_jsx("img", { src: starIcon, alt: "Star Icon" }), "Yeni Oyunlar"] })), gamesGroup === 2 && (_jsxs(_Fragment, { children: [_jsx("img", { src: clockIcon, alt: "Clock Icon" }), "Gelecek Oyunlar"] }))] })) })), _jsxs("div", __assign({ className: "col-lg-6 text-end d-flex align-items-center justify-content-end gap-2" }, { children: [_jsx("div", { className: "home-games-nav-prev swiper-home-prev-".concat(gamesGroup) }), _jsx("div", { className: "home-games-nav-next swiper-home-next-".concat(gamesGroup) }), _jsx("span", __assign({ className: "view-all", onClick: function () {
                                            if (!auth.member)
                                                return loginRequired(navigate);
                                            navigate("/dijital-oyunlar");
                                        } }, { children: "Hepsi" }))] }))] })), _jsx(Swiper, __assign({ modules: [Navigation, Pagination, Autoplay], spaceBetween: 20, slidesPerView: isMobile ? 2 : 5, autoplay: { delay: 5000, disableOnInteraction: false }, navigation: { nextEl: ".swiper-home-next-".concat(gamesGroup), prevEl: ".swiper-home-prev-".concat(gamesGroup) } }, { children: gamesList.map(function (game, key) {
                            var _a, _b, _c, _d;
                            return (_jsx(SwiperSlide, { children: _jsx("div", __assign({ className: "game-card", style: { backgroundImage: "url(".concat(env.cdn_host + "/media/" + game.image, ")") }, onClick: function () { return gameNavigationMiddleware(game, navigate); } }, { children: _jsxs("div", __assign({ className: "play-button-wrapper\n                                                    ".concat(game.is_active !== true && !(((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id) && auth.remaining_games.includes(game.id)) ? "passive" : "", "\n                                                    ").concat(game.is_active !== true && ((_b = auth.member) === null || _b === void 0 ? void 0 : _b.id) && auth.remaining_games.includes(game.id) ? "alerted" : "", "\n                                                ") }, { children: [_jsxs("span", __assign({ className: "play-button-text with-icon ".concat(game.is_active !== true && game.reminer !== true ? (((_c = auth.member) === null || _c === void 0 ? void 0 : _c.id) && auth.remaining_games.includes(game.id) ? 'reminder-set-text' : 'reminder-text') : '') }, { children: [game.is_active === true && _jsx(_Fragment, { children: "HEMEN OYNA" }), game.is_active !== true && game.reminer !== true && (_jsx(_Fragment, { children: ((_d = auth.member) === null || _d === void 0 ? void 0 : _d.id) && auth.remaining_games.includes(game.id)
                                                            ? (_jsx(_Fragment, { children: "HATIRLATICI OLU\u015ETURULDU" }))
                                                            : (_jsxs(_Fragment, { children: [_jsx("img", { src: notificationIcon, alt: "Notification", style: { width: '16px', height: '16px' } }), "HATIRLAT"] })) }))] })), game.is_active === true && (_jsx("span", __assign({ className: "play-button-icon", onClick: function (e) {
                                                    e.stopPropagation();
                                                    if (!auth.member)
                                                        return loginRequired(navigate);
                                                    if (auth.remaining_games.includes(game.id))
                                                        return;
                                                    api.start("post", env.accounting_api + "/games/api/reminder-game/", { game_id: game.id }, true);
                                                } }, { children: _jsx("img", { src: iconRight, alt: ">" }) })))] })) })) }, "home-games-widget-".concat(key)));
                        }) }))] })) })) }));
}
